import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useAppSelector } from '../store/hooks';
import { selectMembershipTier } from '../store/appSlice';
import DashboardNavigation from './DashboardNavigation';

type AccountNavigationProps = Pick<React.ComponentProps<typeof DashboardNavigation>,
  'expanded' | 'mobile' | 'onClose' | 'onToggleExpanded'>;

/** The same account details and navigation actions in every workspace. */
export default function AccountNavigation(props: AccountNavigationProps) {
  const { isAuthenticated, logout } = useAuth();
  const user = useAppSelector((state) => state.app);
  const tier = useAppSelector(selectMembershipTier);

  return <DashboardNavigation
    {...props}
    account={isAuthenticated ? {
      tokens: user.tokens,
      email: user.email,
      tier,
      isPremium: user.is_premium,
      isPlatinum: user.is_platinum,
    } : undefined}
    onSignOut={isAuthenticated ? logout : undefined}
  />;
}
